module.exports = __webpack_public_path__ + "img/couples_16_V.c5a16c8e.webp";